import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Table } from "react-bootstrap";
import ModalInputText from "./ModalInputText";
import ModalInputSelect from "./ModalInputSelect";
import { Store } from "react-notifications-component";
import PermissionContext from "../../../Store/permission-context";
import axios from "axios";
const PermissionModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.showpermissionmodal);
  const [AxiosError, setAxiosError] = useState("");
  const [ThePermissions, setThePermissions] = useState(props.ThePermissions);
  const [Username, setUsername] = useState(props.Username);
  const PCtx = useContext(PermissionContext);

  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);
  // const [NowPaying, setNowPaying] = useState(0);
  // const [PaymentMode, setPaymentMode] = useState("");

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  const EditPermission = (ind, vl) => {
    let PPP = [...ThePermissions];
    let mpp = PPP[ind];

    mpp = { ...mpp, vals: vl };
    PPP[ind] = mpp;

    setThePermissions(PPP);
  };

  const SaveEditedPermission = async () => {
    let SavePerm = {
      ThePermissions: ThePermissions,
      Fullname: props.Fullname,
      Username: Username,
      Admin: PCtx.Username,
    };

    let PERM = await PCtx.connectAxios("saveallpermissions.php", SavePerm);

    if (PERM.includes("Success")) {
      props.cancelModal();
      PCtx.displayAlert(
        "SUCCESS",
        "Permissions for " + props.Fullname + " changed successfully!",
        "success"
      );
    }
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={props.cancelModal}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header style={successBackStyle}>
          <Modal.Title style={{ color: "brown" }}>
            Permissions for {props.Fullname}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Row>
            <Col md={12} sm={12} xs={12}>
              <Row>
                <Col></Col>
                <Col md={12} sm={12} xs={12}>
                  <Table striped bordered responsive>
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Activities</th>
                        <th>Status</th>
                        <th>Change</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ThePermissions.map((pm, index) => (
                        <tr
                          key={index}
                          style={
                            parseInt(pm.vals) === 1
                              ? { backgroundColor: "#80ff00" }
                              : { backgroundColor: "#f75437" }
                          }
                        >
                          <td>{index + 1}</td>
                          <td>{pm.name}</td>
                          <td>
                            {parseInt(pm.vals) === 1 ? "Allowed" : "Disallowed"}
                          </td>
                          <td>
                            <ModalInputSelect
                              myOptions={["Select", "Allow", "Disallow"]}
                              Index={index}
                              myName={pm.name}
                              Action={EditPermission}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
                <Col md={12} sm={12} xs={12}>
                  <Button variant="success" onClick={SaveEditedPermission}>
                    Save Changes
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  );
};

export default PermissionModal;
